import { State } from "./State.js";
import { MenuState } from "./MenuState.js";

export class LoadingState extends State {

    async Enter() {
        console.log("Loading started...");

        try {

            await this.manager.AssetLoader.loadManifestGroup("menu");

            console.log("Loading complete!");

            this.manager.changeState(new MenuState(this.manager));
        } catch (error) {
            console.error("Failed to load menu assets:", error);
        }
    }

    Exit() {

    }
}